import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./lib/i18n";
import AmbientBackground from "./components/AmbientBackground";
import PwaInstallPrompt from "./components/PwaInstallPrompt";

import Landing from "./pages/Landing";
import Apply from "./pages/Apply";
import Success from "./pages/Success";
import MemberLogin from "./pages/MemberLogin";
import MemberVip from "./pages/MemberVip";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminDirectory from "./pages/AdminDirectory";
import Scan from "./pages/Scan";
import Posters from "./pages/Posters";
import StaffLogin from "./pages/StaffLogin";
import StaffDashboard from "./pages/StaffDashboard";
import DoorStaff from "./pages/DoorStaff";
import Privacy from "./pages/Privacy";
import AdminEvent from "./pages/AdminEvent";
import AdminBroadcast from "./pages/AdminBroadcast";
import AdminBanner from "./pages/AdminBanner";

function App() {
    return (
        <LanguageProvider>
            <AmbientBackground />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/join" element={<Apply />} />
                    <Route path="/success" element={<Success />} />
                    <Route path="/member" element={<MemberLogin />} />
                    <Route path="/member/me" element={<MemberVip />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/directory" element={<AdminDirectory />} />
                    <Route path="/scan" element={<Scan />} />
                    <Route path="/admin/posters" element={<Posters />} />
                    <Route path="/admin/door-staff" element={<DoorStaff />} />
                    <Route path="/admin/event" element={<AdminEvent />} />
                    <Route path="/admin/broadcast" element={<AdminBroadcast />} />
                    <Route path="/admin/banner" element={<AdminBanner />} />
                    <Route path="/staff/login" element={<StaffLogin />} />
                    <Route path="/staff" element={<StaffDashboard />} />
                    <Route path="/privacy" element={<Privacy />} />
                </Routes>
            </BrowserRouter>
            <PwaInstallPrompt />
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "rgba(10, 18, 14, 0.92)",
                        border: "1px solid rgba(212,175,55,0.25)",
                        color: "#F5F5F0",
                        fontFamily: "Outfit, sans-serif",
                    },
                }}
            />
        </LanguageProvider>
    );
}

export default App;
